import React from 'react';
import { AuthCheckUser } from '../../Utils/AuthCheck/UserCheck.auth';
import PropTypes from 'prop-types';
import { FormContainer } from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import CheckoutInnerPage from './CheckoutInner.component';
import CartDataProvider from '../../Utils/Users/CartDataProvider';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';

function Message({ content }) {
  return <p>{content}</p>;
}
Message.propTypes = {
  content: PropTypes.string,
};

// Main outer component for the purchase page
function BuyPage() {
  return (
    <AuthCheckUser>
      <HelmetHelper
        title="Checkout"
        description="Checkout page for Yoda Safety Services"
      />
      <FormContainer
        style={{
          alignContent: 'center',
          display: 'flex',
        }}
      >
        <BreadCrumbs one="courses" oneLink={`/online`} two={`Checkout`} />
        <h2>Checkout</h2>
        <CartDataProvider>
          {(cart) => (
            <>
              {cart?.length > 0 ? (
                <CheckoutInnerPage courses={cart} />
              ) : (
                <div>
                  <Message content="Your cart is empty" />
                  <PrimaryButtonComponent
                    span="Go to Courses"
                    functionName={() => (window.location.href = '/online')}
                  />
                </div>
              )}
            </>
          )}
        </CartDataProvider>

        <p style={{ textAlign: 'center', marginTop: '2rem' }}>
          By paying with your card, you acknowledge that your data will be
          processed by PayPal subject to the PayPal Privacy Statement available
          at PayPal.com.
        </p>
        <p style={{ textAlign: 'center' }}>
          Need Help? Call{' '}
          <span style={{ color: 'var(--grey3)' }}>1-902-478-1972 </span>or email
          us at{' '}
          <span style={{ color: 'var(--grey3)' }}>
            yodasafetyservices1@outlook.com
          </span>
        </p>
      </FormContainer>
    </AuthCheckUser>
  );
}

export default BuyPage;
